export const authSettings = {
  redirectPath: '/TRK_Tracker.aspx',
  scopes: ['openid', 'offline_access', 'email', 'profile', 'User.Read'],
};

export interface MicrosoftAuthConfig {
  clientId: string;
  tenantId: string;
  authority: string;
  scope: string;
}

export const authRedirectUri = `${window.location.origin}${authSettings.redirectPath}`;